import { InputAdornment } from "@mui/material";
import React, { useMemo, useRef } from "react";
import { StyledTextField } from "customStyled";
import { autocompleteToken, withTrimHandler } from "utils";
import FormControlUI from "./FormControlUI";

const FormInputUI = (props) => {
  const {
    id,
    autoComplete,
    type,
    placeholder,
    startAdornment = null,
    endAdornment = null,
    multiline = false,
    rows = 4,
    checkType = "text",
    attr = {},
    label,
    required,
    onChange,
    value,
    helperText,
    sx = {},
    inputSx = {},
    height= 40
  } = props;
  const inputRef = useRef(null);

  const startAdornmentUI = useMemo(() => {
    if (startAdornment) {
      return <InputAdornment position="start">{startAdornment}</InputAdornment>;
    }
    return null;
  }, [startAdornment]);
  const endAdornmentUI = useMemo(() => {
    if (endAdornment) {
      return <InputAdornment position="end">{endAdornment}</InputAdornment>;
    }
    return null;
  }, [endAdornment]);

  return (
    <React.Fragment>
      <FormControlUI label={label} required={required} id={id} sx={sx} helperText={helperText}>
        <StyledTextField
          inputRef={inputRef}
          inputProps={{ ...attr }}
          type={type}
          id={id}
          name={id}
          height={height}
          {...withTrimHandler(() => ({ onChange, value }), checkType)}
          startAdornment={startAdornmentUI}
          endAdornment={endAdornmentUI}
          multiline={multiline}
          rows={rows}
          placeholder={`${placeholder}`}
          autoComplete={autocompleteToken(autoComplete)}
          variant="outlined"
          aria-describedby={`${id}-error-text`}
          sx={inputSx}
        />
      </FormControlUI>
    </React.Fragment>
  );
};

export default FormInputUI;
